import { GenDialog } from "@ui";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { getDialogProps } from "@modules/core";
import { clog } from "@libs/utils";

const DialogProvider: FC = (props) => {
  const dialogProps = useSelector(getDialogProps);

  useEffect(() => {
    // You can add side effects here if needed when dialogProps change
    clog("Dialog Props Updated:", dialogProps);
  }, [dialogProps]);

  return (
    <>
      <GenDialog open={dialogProps?.open || false} {...dialogProps} />
    </>
  );
};

export default DialogProvider;
